<style>
	/* .edi-reciept {
		overflow: hidden;
	} */
	.edi-reciept{
		padding-bottom: 50px;
	}
	.edi-reciept .foot ul {
		position: absolute;
		width: 100%;
		bottom: 0;
		margin: 0;
		padding: 0;
		background-color: #f8f8f8;
		border-top: 1px #d1d1d1 solid;
	}
	.edi-reciept-top {
		margin-top: 1em;
	}
	.edi-reciept .ui-listview,
	.edi-reciept .ui-listview li {
		border: none;
		overflow: hidden;
	}
	.edi-reciept .ui-listview li > a {
		display: block;
		padding: .7em 1em;
		font-size: 14px;
	}
	.edi-reciept .ui-listview {
		margin-bottom: 1em;
	}
	.edi-reciept .head {
		border-bottom: 1px #cecece solid;
		position: relative;
	}
	.edi-reciept .head h4 {
		margin: 0;
		padding: .6em 1em;
		font-weight: normal;
	}
	.edi-reciept .head a {
		position: absolute;
		right: 0;
		top: 0;
		color: #656565;
		padding: .6em 1.6em .6em 1em;
	}
	.edi-reciept .ui-listview ul {
		margin: 0;
		padding: 0;
	}
	.edi-reciept .ui-listview ul li {
		float: left;
		width: 25%;
		text-align: center;
	}
	.edi-reciept .ui-listview ul i {
		width: 33px;
		height: 29px;
		display: block;
		margin: .3em auto;
		background-size: 33px 29px;
		background-repeat: no-repeat;
		position: relative;
	}
	.edi-reciept .ui-listview ul i em{
		position: absolute;
	    top: -5px;
	    left: 20px;
	    background-color: #e02222;
	    color: #ffffff;
	    padding: 0px 3px;
	    height: 16px;
	    border-radius: 3px;
	    font-size: 0.9em;
	    font-style: normal;
	}
	.edi-reciept .order .none i {
		background-image: url('../assets/reciept/order-1.png');
	}
	.edi-reciept .order .wait i {
		background-image: url('../assets/reciept/order-2.png');
	}
	.edi-reciept .order .done i {
		background-image: url('../assets/reciept/order-3.png');
	}
	.edi-reciept .refund .wait i {
		background-image: url('../assets/reciept/refund-1.png');
	}
	.edi-reciept .refund .done i {
		background-image: url('../assets/reciept/refund-2.png');
	}
</style>
<template>
<div class="edi-reciept">
	<ul class="ui-listview edi-reciept-top order">
		<li>
			<div class="head">
				<h4>餐企订单</h4>
				<router-link :to="{ path: '/all-order-bill', query: { bill_state: '10,11,12,13,14', bill_font: '未处理,待发货,已发货,已收货 待确认, 已收货 已确认'}}" class="ui-btn-icon-right ui-icon-carat-r">查看全部订单</router-link>
			</div>
			<ul>
				<li><router-link :to="{ path: '/all-order-bill', query: { bill_state:'10', bill_font: '未处理'}}" class="none">
					<i><em v-if="countShow(count.order_unhandled_num)">{{count.order_unhandled_num}}</em></i>未处理
				</router-link>
				</li>
				<li><router-link :to="{ path: '/all-order-bill', query: { bill_state:'11', bill_font: '待发货'}}" class="wait">
					<i><em v-if="countShow(count.order_accept_num)">{{count.order_accept_num}}</em></i>待发货
				</router-link>
				</li>
				<li><router-link :to="{ path: '/all-order-bill', query: { bill_state:'12', bill_font: '已发货'}}" class="done"><i></i>已发货</router-link></li>

				<li>
					<router-link :to="{ path: '/all-order-bill', query: { bill_state:'13', bill_font: '已收货 待确认'}}" class="done">
						<i><em v-if="countShow(count.order_received_num)">{{count.order_received_num}}</em></i>已收货
					</router-link>
				</li>
				<li>
					<router-link :to="{ path: '/all-order-bill', query: { bill_state:'14,15,16,17', bill_font: '已收货 已确认'}}" class="done">
						<i><em v-if="countShow(count.order_confirmed_num)">{{count.order_confirmed_num}}</em></i>已确认
					</router-link>
				</li>
			</ul>
		</li>
	</ul>
	<ul class="ui-listview refund">
		<li>
			<div class="head">
				<h4>餐企退单</h4>
				<router-link :to="{ path: '/all-return-bill', query: { bill_state: '20,21',bill_font: '未确认,已确认' }}" class="ui-btn-icon-right ui-icon-carat-r">查看全部退单</router-link>
			</div>
			<ul>

				<li>
					<router-link :to="{ path: '/all-return-bill', query: { bill_state: '20',bill_font: '未确认' }}" class="wait">
					<i><em v-if="countShow(count.reverse_uncfmd_num)">{{count.reverse_uncfmd_num}}</em></i>未确认
					</router-link>
				</li>
				<li>
					<router-link :to="{ path: '/all-return-bill', query: { bill_state: '21',bill_font: '已确认'}}" class="done">
					<i></i>已确认
					</router-link>
				</li>
			</ul>
		</li>
	</ul>
	<ul class="ui-listview refund">
		<li>
			<div class="head">
				<h4>餐企报价单</h4>
				<router-link :to="{ path: '/quotation-bill', query: { bill_state: '30,31,32,35',bill_font: '未确认,已同意,已确认,已定价' }}"
					class="ui-btn-icon-right ui-icon-carat-r">查看全部报价单
				</router-link>
			</div>
			<ul>
				<li>
					<router-link :to="{ path: '/quotation-bill', query: { bill_state: '30',bill_font: '未确认' }}" class="wait">
					<i><em v-if="countShow(count.quoter_unhandled_num)">{{count.quoter_unhandled_num}}</em></i>未确认
					</router-link>
				</li>
				<li>
					<router-link :to="{ path: '/quotation-bill', query: { bill_state: '31',bill_font: '已同意'}}" class="done">
					<i><em v-if="countShow(count.quoter_accept_num)">{{count.quoter_accept_num}}</em></i>已同意
					</router-link>
				</li>
				<li><router-link :to="{ path: '/quotation-bill', query: { bill_state: '32',bill_font: '已确认'}}" class="done"><i></i>已确认</router-link></li>
			</ul>
		</li>
	</ul>
	<!-- 餐企询价单 -->
	<ul class="ui-listview refund">
		<li>
			<div class="head">
				<h4>餐企询价单</h4>
				<router-link :to="{ path: '/inquiry-price-bill', query: { bill_state: '40,41,42',bill_font: '未确认,已同意,已确认' }}"
					class="ui-btn-icon-right ui-icon-carat-r"
				>查看全部询价单</router-link>
			</div>
			<ul>
				<li>
					<router-link :to="{ path: '/inquiry-price-bill', query: { bill_state: '40',bill_font: '未确认' }}" class="wait">
					<i><em v-if="countShow(count.inquiry_unhandled_num)">{{count.inquiry_unhandled_num}}</em></i>未确认
					</router-link>
				</li>
				<li>
					<router-link :to="{ path: '/inquiry-price-bill', query: { bill_state: '41',bill_font: '已同意'}}" class="done">
					<i><em v-if="countShow(count.inquiry_accept_num)">{{count.inquiry_accept_num}}</em></i>已同意
					</router-link>
				</li>
				<li><router-link :to="{ path: '/inquiry-price-bill', query: { bill_state: '42',bill_font: '已确认'}}" class="done"><i></i>已确认</router-link></li>
			</ul>
		</li>
	</ul>
	<ul class="ui-listview refund">
		<li>
			<div class="head">
				<h4>餐企对账单</h4>
				<router-link :to="{ path: '/account-check-bill', query: { bill_state: '0,1',bill_font: '未确认,已确认' }}" class="ui-btn-icon-right ui-icon-carat-r">查看全部对账单</router-link>
			</div>
			<ul>
				<li>
					<router-link :to="{ path: '/account-check-bill', query: { bill_state: '0',bill_font: '未确认' }}" class="wait">
					<i><em v-if="countShow(count.arap_unhandled_num)">{{count.arap_unhandled_num}}</em></i>未确认
					</router-link>
				</li>
				<li>
					<router-link :to="{ path: '/account-check-bill', query: { bill_state: '1',bill_font: '已确认'}}" class="done">
					<i></i>已确认
					</router-link>
				</li>
			</ul>
		</li>
	</ul>
	<!-- 供货商对账单 -->
	<ul class="ui-listview refund">
		<li>
			<div class="head">
				<h4>供货商对账单</h4>
				<router-link :to="{ path: '/supplier-account-check-bill', query: { bill_state: '0,1',bill_font: '未对账,已对账' }}"
					class="ui-btn-icon-right ui-icon-carat-r"
				>查看全部对账单</router-link>
			</div>
			<ul>
				<li>
					<router-link :to="{ path: '/supplier-account-check-bill', query: { bill_state: '0',bill_font: '未对账' }}" class="wait">
					<i><em v-if="countShow(count.reconciliation_unhandled_num)">{{count.reconciliation_unhandled_num}}</em></i>未对账
					</router-link>
				</li>
				<li>
					<router-link :to="{ path: '/supplier-account-check-bill', query: { bill_state: '1',bill_font: '已对账'}}" class="done">
					<i><em v-if="countShow(count.reconciliation_accept_num)">{{count.reconciliation_accept_num}}</em></i>已对账
					</router-link>
				</li>
			</ul>
		</li>
	</ul>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
</div>
</template>
<!--{{{ script -->
<script>
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			msg: [],
			tips: false,
			tipsauto: false,
			btnNum: 1,
			tipsFont: '',
			count: {},
			deviceHeight: this.$root.deviceHeight,
			transitionName: 'page-next',
			sec: 1500,
			store: GlobalStore
		}
	},
	components: {
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	created () {
		this.store.goodsTotalInfo.filterShow = true
		// 如果筛选条件更改过,清空筛选条件 shang 2017/10/19
		if (this.store.billFilterData.filterFlag) {
			this.filterHandle()
		}
		this.$http.get('/cldEdi/business/billCount').then(response => {
			this.count = response.body.data
		}, (response) => {
			var self = this
			self.tipsauto = true
			self.tipsFont = '服务中断，稍后请重试！'
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		})
	},
	methods: {
		filterHandle () {
			this.store.billFilterData.filterFlag = false
			this.store.billFilterData.filterBillState = ''
			this.store.billFilterData.filterBillStateFont = ''
			this.store.billFilterData.filterStartDate = ''
			this.store.billFilterData.filterEndDate = ''
			this.store.billFilterData.filterBillSort = ''
			this.store.billFilterData.filterBillSortFont = ''
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		countShow (val) {
			if (val === 0) {
				return false
			} else {
				return true
			}
		}
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Reciept.vue?ba0b24e2